var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tab', _vm.selected === _vm.index ? 'tab--selected' : '', _vm.disabled ? 'tab--disabled' : '']},[_c('div',{on:{"click":function($event){_vm.createRipple($event); _vm.changeTab(_vm.index)}}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }